import { GQLPhotoItemFragment } from 'components/page/ForeignProfile/gql/__generated__/Photos'

/**
 *
 * @param photo - главная фото в рейтинге
 * @param extraPhotos - остальные фото в рейтинге
 * @param restPhotos - все фото в профиле которые совпадают с фото выше
 * @returns
 * Проблема в том что фото в рейтинге отличаются от фото в профиле и чтобы хоть как то сделать правильно
 * 1. Берем главное фото в рейтинге
 * 2. Берем остальные фото в рейтинге
 * 3. Объединяем 1 и 2
 * 4. Создаем массив id
 * 5. Фильтруем повторы сравнивая с массивом из всех фото что в профиле
 * 6. Объединяем и отдаем в компонент.
 */
export const mergePhotos = (
  photo: GQLPhotoItemFragment,
  extraPhotos: GQLPhotoItemFragment[] = [],
  restPhotos: GQLPhotoItemFragment[] = []
) => {
  const photos = [
    {
      ...photo,
      main: true,
    },
    ...extraPhotos,
  ]

  const idsArray = new Set(photos.map((item) => item.photoId))

  const filteredArray = restPhotos
    .filter((item) => !idsArray.has(item.photoId))
    .map((item) => ({
      ...item,
      portrait: false,
      main: false,
    }))

  return [...photos, ...filteredArray]
}
